import { api } from './apiClient.js';

/** POST /v1/tenant/document/list */
export const listDocuments = (body) => api.post('/v1/tenant/document/list', body);

/** POST /v1/tenant/document/create */
export const createDocument = (body) => api.post('/v1/tenant/document/create', body);

/** POST /v1/tenant/document/attach */
export const attachDocument = (body) => api.post('/v1/tenant/document/attach', body);

/**
 * POST /v1/workspace/document/:uuid/agents/:agent_id/unassign
 * (tenant_id unused in current contract)
 */
export const unassignAgentFromDocument = (documentUuid, agentId) =>
  api.post(`/v1/workspace/document/${encodeURIComponent(documentUuid)}/agents/${encodeURIComponent(agentId)}/unassign`);

/** POST /v1/tenant/document/assign-agent */
export const assignAgentToDocument = (body) => api.post('/v1/tenant/document/assign-agent', body);

/** POST /v1/workspace/document/delete */
export const deleteDocument = (body) => api.post('/v1/workspace/document/delete', body);
